// Content pillars for the BWM Marketing Module. Hardcoded by design —
// the doc reviewing process should be the ceremony for changing these,
// not a settings page in the app. Colors come from the Cover Image
// System (typography-first, brand-color-driven).

export const PILLARS = [
  {
    id: 'tax_planning',
    label: 'Tax Planning Strategies',
    bg: '#006D78',         // Deep Teal
    accent: '#3EAAD0',     // Sky Blue
    text: '#F0EDE8',       // Bone
  },
  {
    id: 'implementation',
    label: 'Implementation & Accountability',
    bg: '#2596BE',         // Bullogic Blue
    accent: '#F0EDE8',     // Bone
    text: '#F0EDE8',
  },
  {
    id: 'entity',
    label: 'Entity & Real Estate Tax',
    bg: '#0D2B2E',         // Dark
    accent: '#3EAAD0',     // Sky Blue
    text: '#F0EDE8',
  },
  {
    id: 'retirement',
    label: 'Retirement Tax & Distributions',
    bg: '#3EAAD0',         // Sky Blue
    accent: '#006D78',     // Deep Teal
    text: '#0D2B2E',
  },
  {
    id: 'foundation',
    label: 'Financial Foundation & Cash Flow',
    bg: '#F0EDE8',         // Bone
    accent: '#006D78',     // Deep Teal
    text: '#0D2B2E',
  },
  {
    id: 'mistakes',
    label: 'Avoid These Mistakes',
    bg: '#FF6E83',         // Rose
    accent: '#0D2B2E',
    text: '#F0EDE8',
  },
  {
    id: 'case_studies',
    label: 'Case Studies',
    bg: '#0D2B2E',
    accent: '#3EAAD0',
    text: '#F0EDE8',
  },
];

export const PILLAR_BY_ID = Object.fromEntries(PILLARS.map(p => [p.id, p]));

export function getPillar(id) {
  return PILLAR_BY_ID[id] || null;
}

export function getPillarLabel(id) {
  return PILLAR_BY_ID[id]?.label || id || '—';
}

// Statuses control queue depth + cadence math. Order matters for sort.
// Channel-aware stage set (handoff 5.1) — sql/26 migrated the old
// vocabulary (outlined -> drafting, drafted -> editing). The union of
// both channels' stages lives here so the older tools (Content Log,
// entry modal) keep working; the board uses stages.js per channel.
export const CONTENT_STATUSES = [
  { id: 'idea',      label: 'Idea',      color: 'bg-gray-100 text-gray-600' },
  { id: 'planned',   label: 'Planned',   color: 'bg-chip text-navy' },
  { id: 'drafting',  label: 'Drafting',  color: 'bg-bullogic-blue/15 text-bullogic-blue' },
  { id: 'scripting', label: 'Scripting', color: 'bg-bullogic-blue/15 text-bullogic-blue' },
  { id: 'recording', label: 'Recording', color: 'bg-rose/15 text-rose' },
  { id: 'editing',   label: 'Editing',   color: 'bg-amber-100 text-amber-700' },
  { id: 'graphics',  label: 'Graphics',  color: 'bg-sky-blue/20 text-navy' },
  { id: 'scheduled', label: 'Scheduled', color: 'bg-deep-teal/15 text-deep-teal' },
  { id: 'published', label: 'Published', color: 'bg-deep-teal text-white' },
];

export const STATUS_BY_ID = Object.fromEntries(CONTENT_STATUSES.map(s => [s.id, s]));

// "Queue depth" = posts not yet published but past idea stage.
// Doc rule: ≥ 2 = green, 1 = yellow, 0 = red, surge block within 7 days.
export function isInQueue(status) {
  return status !== 'idea' && status !== 'published' && STATUS_BY_ID[status] != null;
}

export const POST_TYPES = [
  { id: 'educational',          label: 'Educational' },
  { id: 'case_study_companion', label: 'Case Study Companion' },
];

export const SEARCH_INTENTS = [
  { id: 'informational', label: 'Informational' },
  { id: 'commercial',    label: 'Commercial' },
  { id: 'navigational',  label: 'Navigational' },
  { id: 'transactional', label: 'Transactional' },
];
